import { css } from "@emotion/react";
import Button from "../Button";
import { forwardRef } from "react";
import { DrawerProps } from "./types";
import { styles } from "./styles";

export const DrawerHeader = forwardRef<
  HTMLDivElement,
  DrawerHeaderProps & {
    /**
     * Unique ID for the header title, used for accessibility purposes.
     * Generated in DrawerPanel and passed down to ensure consistency between the header and the aria-labelledby attribute on the drawer container.
     */
    titleId: string;
  }
>(({ children, titleIcon, headerButtons, onClose, titleId }, ref) => {
  return (
    <div className="kit-drawer-header" css={[styles.header.base]} ref={ref}>
      {(children || titleIcon) && (
        <div css={[styles.header.content]}>
          {titleIcon}
          <div id={titleId} css={[styles.header.title]}>
            {children}
          </div>
        </div>
      )}
      <div css={[styles.header.actions]}>
        {headerButtons}
        <Button
          css={[
            css`
              --icon-fill-color: var(--color-tertiary);
            `
          ]}
          ariaLabel="Close drawer"
          variant="ghost"
          prefix="X"
          onClick={onClose}
          className="kit-drawer-close-button"
        />
      </div>
    </div>
  );
});

DrawerHeader.displayName = "Drawer.Header";

export type DrawerHeaderProps = Pick<
  DrawerProps,
  "titleIcon" | "headerButtons" | "onClose"
> & {
  children?: React.ReactNode;
};
